import styled, { css } from 'styled-components'

import PropTypes from 'prop-types'
import Tooltip from '@shared/components/Tooltip'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;

  ${(props) =>
    props.horizontal &&
    css`
      flex-direction: row;
      flex-wrap: wrap;
    `}

  .radio {
    &__name {
      margin-bottom: 0.5rem;
      width: 100%;
      font-size: 0.875rem;
    }

    &__item {
      display: flex;
      align-items: center;
      margin-bottom: 0.25rem;
      margin-right: 0.5rem;
    }

    &__label {
    }

    &__input {
      margin-right: 0.5rem;
    }
  }
`

export const Error = styled(Tooltip)`
  margin-left: auto;
  padding: 0rem 1rem;

  span {
    background: #c53030;
    color: ${(props) => props.theme.white};
    &::before {
      border-color: #c53030 transparent;
    }
  }
`

Container.propTypes = {
  horizontal: PropTypes.bool
}
